import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { createTransactions } from "../../../../network/network";
import NotificationWithIcon from "../../../../components/NotificationWithIcon";
import { useState } from "react";
import { isSameBranch } from "../../../../utils/branchScope";
import {
  handleApiError,
  showAppError,
} from "../../../../utils/errorHandler";
import {
  OrderType,
  TransactionStatus,
} from "../../../../configs/constants";

const normalizeTagIds = (values) => {
  if (!Array.isArray(values)) return [];
  return values
    .map((value) => (value && typeof value === "object" ? value.id : value))
    .filter((value) => value !== undefined && value !== null);
};

const AddOrder = ({
  diningTableId,
  waiterId,
  waiterBranchId,
  branchId,
  items,
  reloadCallback,
  onTakeawayCheckout,
}) => {
  const [loadingBTN, setLoadingBTN] = useState(false);
  const [orderTypeModalOpen, setOrderTypeModalOpen] = useState(false);
  const { t } = useTranslation();

  const createDineInOrder = () => {
    setLoadingBTN(true);

    if (waiterId && waiterBranchId && !isSameBranch(waiterBranchId, branchId)) {
      showAppError(t("waiter_not_available_for_branch"));
      setLoadingBTN(false);
      return;
    }

    const transactionObj = {
      transaction_status: TransactionStatus.InProgress,
      order_type: OrderType.DineIn,
      items: JSON.stringify(
        (items || []).map((item) => ({
          id: item.product_id ? item.product_id : item.id,
          qty: item.quantity,
          price: item.price,
          tags: normalizeTagIds(item.selectedTagIds),
        })),
      ),
    };

    if (diningTableId) transactionObj.dining_table_id = diningTableId;
    if (waiterId) transactionObj.waiter_id = waiterId;

    createTransactions(transactionObj)
      .then((response) => {
        const data = response?.data || response?.response?.data;

        if (data?.success === true) {
          NotificationWithIcon(
            "success",
            t("order_added"),
            t("order_added_successfully"),
          );
          reloadCallback?.();
        } else if (data?.success === false) {
          handleApiError(response, t);
        }
      })
      .catch((err) => {
        if (err?.errorFields) return;
        if (err?.message === "INSUFFICIENT_CASH") return;

        handleApiError(err, t);
      })
      .finally(() => {
        setLoadingBTN(false);
      });
  };

  const handleAddOrderClick = () => {
    if (!items || items.length === 0) return;
    setOrderTypeModalOpen(true);
  };

  return (
    <>
      <Button
        type="default"
        onClick={handleAddOrderClick}
        loading={loadingBTN}
        disabled={loadingBTN || !items?.length}
      >
        {t("add_order")}
      </Button>

      <Modal
        title={null}
        open={orderTypeModalOpen}
        onCancel={() => setOrderTypeModalOpen(false)}
        footer={null}
        centered
        destroyOnClose={false}
      >
        <div className="option-modal-wrapper">
          <h2 className="option-modal-title" style={{ marginBottom: "40px" }}>
            {t("how_would_you_like_to_order")}
          </h2>

          <div className="option-footer">
            <Button
              type="primary"
              htmlType="button"
              className="btn-confirm"
              onClick={() => {
                setOrderTypeModalOpen(false);
                createDineInOrder();
              }}
            >
              {t("dine_in")}
            </Button>

            <Button
              type="primary"
              htmlType="button"
              className="btn-confirm"
              onClick={() => {
                setOrderTypeModalOpen(false);
                onTakeawayCheckout?.();
              }}
            >
              {t("takeaway")}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddOrder;
